import React from 'react';
import Select from 'react-select';

const SELECT_ALL = '__select_all__';

function GatewaySelector({ gateways, selected, onChange, onFocus=null, highlight=false }) {
  const baseOptions = gateways.map(gw => ({
    value: gw.vrvGatewayId,
    label: gw.name ? `${gw.name}` : gw.vrvGatewayId,
    iduCount: gw.iduCount,
    connectivityStatus: gw.connectivityStatus,
  }));

  const allSelected = selected?.length === gateways.length && gateways.length > 0;
  const selectAllOption = { value: SELECT_ALL, label: 'Select All', iduCount: null };
  const options = gateways.length > 1 ? [selectAllOption, ...baseOptions] : baseOptions;

  const handleChange = opts => {
    if (!opts) return onChange([]);
    if (opts.some(o => o.value === SELECT_ALL)) {
      if (allSelected) onChange([]);
      else onChange(baseOptions.map(o => o.value));
    } else {
      onChange(opts.map(o => o.value));
    }
  };

  const value = baseOptions.filter(o => selected?.includes(o.value));

  return (
    <div style={{ width: 'auto', fontFamily: 'Manrope',width:350 }}>
      <Select
        options={options}
        isMulti
        value={value}
        onChange={handleChange}
        placeholder="Select Floors"
        isClearable
        menuPortalTarget={document.body}
        menuPosition="fixed"
        onMenuOpen={onFocus || undefined}
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 }),
          control: (base, state) => ({
            ...base,
            borderRadius: 8,
            borderColor: highlight && !state.isFocused ? '#FF0000' : '#e0e0e0',
            fontSize: 13,
            fontFamily: 'Manrope',
            minHeight: 30,
            boxShadow: highlight && !state.isFocused ? '0 0 0 0.2px #FF0000' : 'none',
            '&:hover': { borderColor: highlight ? '#FF0000' : '#2050ff' },
          }),
          valueContainer: base => ({
            ...base,
            maxHeight: 36,
            overflowY: 'auto',
          }),
          option: (base, state) => ({
            ...base,
            fontSize: 13,
            fontFamily: 'Manrope',
            backgroundColor: state.isSelected ? 'rgba(32,80,255,0.1)' : state.isFocused ? '#f5f7ff' : '#fff',
            color: state.isSelected ? '#2050ff' : '#333',
          }),
        }}
        formatOptionLabel={opt => (
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {opt.value === SELECT_ALL
              ? <strong>{opt.label}</strong>
              : opt.label}
            {opt.iduCount != null && (
              <span style={{ color: '#aaa', fontSize: 11 }}>
                {opt.iduCount} IDUs
              </span>
            )}
            {opt.connectivityStatus != null && (
              <span style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: opt.connectivityStatus === 'ONLINE' ? '#22c55e' : '#ef4444',
                flexShrink: 0,
              }} />
            )}
          </span>
        )}
      />
    </div>
  );
}

export default GatewaySelector;
